// Copyright (c) 2023 MOCA Systems, Inc. All rights reserved.
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import * as appStrings from '@touchplan/strings';

export enum MessageType {
	Error = 'error',
	Warning = 'warning',
	Info = 'info',
	Success = 'success',
}
export interface IMessageHandlerBaseData {
	messageType: MessageType;
	error: string;
	message: string;
	action?: string;
}

@Component({
	selector: 'message-handler-base',
	templateUrl: 'message-handler-base.component.html',
	styleUrls: ['message-handler-base.component.scss'],
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatSnackBarModule, MatIconModule, MatDialogModule],
})
export class MessageHandlerBaseComponent implements OnInit {
	public containerClass: string;
	public icon: string;
	public title: string;
	public errorMessage: string;
	public actionColor: 'primary' | 'error' | 'warn';
	public action?: string;

	constructor(
		@Inject(MAT_SNACK_BAR_DATA) public data: IMessageHandlerBaseData,
		private readonly ref: MatSnackBarRef<MessageHandlerBaseComponent>
	) {}

	public ngOnInit(): void {
		this.containerClass = `${this.data.messageType}-message`;
		this.errorMessage =
			this.data?.error?.length > 120 ? `${this.data.error.slice(0, 120)}...` : this.data?.error;

		switch (this.data.messageType) {
			case 'error':
				this.icon = 'gpp_maybe';
				this.title = appStrings.BANNER_MESSAGE_ERROR_TITLE;
				this.actionColor = 'error';
				break;

			case 'warning':
				this.icon = 'warning';
				this.title = appStrings.BANNER_MESSAGE_WARNING_TITLE;
				this.actionColor = 'warn';
				break;

			case 'info':
				this.icon = 'info';
				this.title = appStrings.BANNER_MESSAGE_INFO_TITLE;
				this.actionColor = 'primary';
				break;

			case 'success':
				this.icon = 'check_circle';
				this.title = appStrings.BANNER_MESSAGE_SUCCESS_TITLE;
				this.actionColor = 'primary';
				break;
		}

		this.action = this.data.action;
	}

	onDismiss() {
		this.ref.dismissWithAction();
	}
}
